import { create } from 'zustand'
import { supabase } from '../lib/agents/db'
import { uiState } from './uistate'

interface AppState {
  agentLoading: boolean
  setAgentLoading: (loading: boolean) => void
  agent: Agent | null
  setAgent: (agent: Agent | null) => void
}



export const useAppStore = create<AppState>((set) => ({
  agentLoading: false,
  setAgentLoading: (loading) => set({ agentLoading: loading }),
  agent: null,
  setAgent: (agent) => set({ agent }),
}))

export const app = {

  uiState,

  get agent() {
    return useAppStore.getState().agent
  },
  set agent(value: Agent | null) {
    useAppStore.getState().setAgent(value)
  },
  get state() {
    return {
      get agentLoading() {
        return useAppStore.getState().agentLoading
      },
      set agentLoading(loading: boolean) {
        useAppStore.getState().setAgentLoading(loading)
      }
    }
  },

  async fetchAPIkeys(teamId?: string) {
    if (!teamId) {
      console.error('Error fetching api keys: No team ID provided')
      return {}
    }
    const { data, error } = await supabase.from("api_keys").select("*").eq("team_id", teamId)
    if (error) {
      console.error('Error fetching api keys:', error)
      return {}
    }
    const formattedApiKeys = data?.reduce<APIKeys>((acc, key) => {
      if (key.type && key.key) {
        acc[key.type as keyof APIKeys] = key.key
      }
      return acc
    }, {})
    return formattedApiKeys
  },

  // groups,
  // pages,


}
